import { _analyticsQueue, type AnalyticsEvents } from '@/utils/analytics-events';
import { hasAnalyticsConsent } from '@/utils/consent';

export const useAnalytics = () => {
    const track = <K extends keyof AnalyticsEvents>(event: K, props: AnalyticsEvents[K]): void => {
        if (import.meta.server) return;           // SSR no-op
        // No CookieYes analytics consent (or Global Privacy Control) → drop it.
        // Nothing is queued for later: an event from before consent is not sent.
        if (!hasAnalyticsConsent()) return;
        _analyticsQueue.push(event, props);
    };
    return { track };
};
